import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton, Button, Container, Grid } from '@mui/material';


import Navbar from '../components/Navbar';
import Secone from './homePagesec/Secone';
import Sectwo from './homePagesec/Sectwo';
import Secthree from './homePagesec/Secthree';
import SecFour from './homePagesec/SecFour';
import SecFive from './homePagesec/SecFive';
import SecSix from './homePagesec/SecSix';
import SecSeven from './homePagesec/SecSeven';

function Home() {
  const [bgIndex, setBgIndex] = useState(0);



  return (
    <>
      <Navbar />
      <Box>
        {/* First Section - Background Image Carousel */}
        <Secone/>

        {/* Second Section - About Section */}
        <Sectwo />

        {/* Services Section */}
        <Secthree/>

        <SecFour/>

        <SecFive/>
        <SecSix/>
        <SecSeven/>

  
      </Box>
    </>
  );
}

export default Home;
